/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Swipe4Work Admin API
 * OpenAPI spec version: 0.1.1
 */

/**
 * Permission level for a resource
 */
export type PermissionLevel = typeof PermissionLevel[keyof typeof PermissionLevel];


export const PermissionLevel = {
  Read: 'Read',
  Write: 'Write',
  Delete: 'Delete',
} as const;
